<script setup>
import { ref, computed, getCurrentInstance } from 'vue'
import FreightExchangeControl from './FreightExchangeControl.vue'

// In Vue 2.7 con script setup, accedi allo store tramite getCurrentInstance
const instance = getCurrentInstance()
const store = instance.proxy.$store

const props = defineProps({
    onTogglePanel: {
        type: Function,
        required: false
    },
    collapsed: {
        type: Boolean,
        default: true
    },
    utilityPanel: {
        type: String,
        default: null
    }
})

const getFEOffers = computed(() => store.getters.getFEOffers)
const getFEUser = computed(() => store.getters.getFEUser)

// Zoom corrente dalla mappa principale
const currentZoom = computed(() => {
    const mainMapInstance = store.state.geoFleet.mainMapInstance
    if (mainMapInstance && mainMapInstance.mapObject) {
        return mainMapInstance.mapObject.getZoom()
    }
    return 0
})

// Visibilità del controllo
const showFreightExchangeControl = computed(() => {
    return currentZoom.value >= 11 && getFEUser.value !== 401 && getFEUser.value !== null
})

// Verifica se il pannello FreightExchange è aperto
const isFreightExchangePanelOpen = computed(() => {
    return props.utilityPanel === 'freight-exchange'
})
const FreightExchangeLocation = computed(() => {
    // Se abbiamo accesso alla mappa principale attraverso lo store
    const mainMapInstance = store.state.geoFleet.mainMapInstance
    if (mainMapInstance && mainMapInstance.mapObject) {
        const map = mainMapInstance.mapObject
        const center = map.getCenter()
        const bounds = map.getBounds()
        // Calcola il punto più a nord del rettangolo dei bounds (stesso lng del centro)
        const L = require('leaflet')
        const north = L.latLng(bounds.getNorth(), center.lng)
        // Usa la funzione 'distanceTo' di Leaflet per calcolare il raggio in metri
        const radius = center.distanceTo(north)
        return {
            lat: center.lat,
            lng: center.lng,
            radius: radius
        }
    }
    return {
        lat: null,
        lng: null,
        radius: null
    }
})

const isHovered = ref(false)

const handleMainClick = () => {
    if (props.onTogglePanel) {
        props.onTogglePanel('freight-exchange')
    }
}


</script>

<template>
    <div v-if="collapsed" :class="['buttons-wrapper mt-2', { 'expanded': isHovered }]"
        @mouseenter="isHovered = true" @mouseleave="isHovered = false">
        <!-- <golia-button class="first-button" :variant="variant" icon="fa-kit fa-goliaexchange" /> -->
        <i class="fa-kit fa-goliaexchange first-button btn" @click="handleMainClick">
            <div v-if="getFEOffers && getFEOffers.length > 0" class="ge-offers ">
                {{ getFEOffers.length }}
            </div>
        </i>
        <div v-if="!isFreightExchangePanelOpen" :class="['second-button-wrapper', { 'visible': isHovered }]">
            <freight-exchange-control :disabled="!showFreightExchangeControl" :visible="true"
                :location="FreightExchangeLocation" />
        </div>
    </div>
    <div v-else class="buttons-wrapper-expanded" @click="handleMainClick">
        <!-- <golia-button class="first-button" :variant="variant" icon="fa-kit fa-goliaexchange" /> -->
        <div>
            <i class="fa-kit fa-goliaexchange first-button btn">
                <div v-if="getFEOffers && getFEOffers.length > 0" class="ge-offers">
                    {{ getFEOffers.length }}
                </div>
            </i>
            <span>
                {{ __('freight_exchange.title') }}
            </span>
        </div>
        <freight-exchange-control v-if="!isFreightExchangePanelOpen" class="align-items-end"
            :disabled="!showFreightExchangeControl" :visible="true" :location="FreightExchangeLocation"
            buttonClass="bg-main-gray" />
    </div>
</template>

<style scoped>
.buttons-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: auto;
    padding-left: 10px;
    transition: padding-right 0.3s ease-out;
}

.buttons-wrapper-expanded {
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    justify-content: space-between;

    &:hover {
        background-color: rgba(242, 242, 242, 0.5);

        .first-button {
            background-color: var(--dark-blue);
            color: #fff;
        }
    }
}

.buttons-wrapper.expanded {
    padding-right: 45px;
}

.first-button {
    position: relative;
    z-index: 2;
    font-size: 16px;
    color: #262626;
    background-color: #dde1e7;
    padding: 9px 10px;
    border-radius: 50px;
    margin-right: 10px;

    &:hover {
        background-color: var(--dark-blue);
        color: #fff;
    }
}

.second-button-wrapper {
    position: absolute;
    left: 10px;
    top: 0;
    opacity: 0;
    transition: opacity 0.3s ease-out, transform 0.3s ease-out;
    pointer-events: none;
    z-index: 1;

    &.visible {
        opacity: 1;
        transform: translateX(calc(150%));
        pointer-events: all;
    }
}

.ge-offers {
    content: attr(data-counter);
    position: absolute;
    top: -10px;
    right: -10px;
    background: var(--success);
    padding: 5px;
    line-height: 1;
    font-size: 10px;
    color: #fff;
    border-radius: 4px;
    font-family: "Font Awesome 6 Pro";
    font-weight: bold;
}
</style>